"use strict";

require("./stringhelpers");